import React, { useEffect } from "react";
import { BrowserRouter, Router, Routes, Route } from "react-router-dom";

import "./styles/sass/main.scss";
import "./styles/css/utility.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import LandingPage from "./pages/main-pages/landing-page/LandingPage";
import TermsPage from "./pages/main-pages/terms-page/TermsPage";
import MainLayout from "./layouts/main-layout/MainLayout";
import AdListingPage from "./pages/main-pages/ad-listing-page/AdListingPage";
import AdPage from "./pages/main-pages/ad-page/AdPage";
import CreateAdPage from "./pages/main-pages/create-ad-page/CreateAdPage";
import SellerProfilePage from "./pages/main-pages/seller-profile-page/SellerProfilePage";
import ProfileSettingsPage from "./pages/main-pages/profile-settings-page/ProfileSettingsPage";
import AuthLayout from "./layouts/auth-layout/AuthLayout";
import EmailVerificationPage from "./pages/auth-pages/email-verify-page/EmailVerificationPage";
import LoginPage from "./pages/auth-pages/login-page/LoginPage";
import RegistrationPage from "./pages/auth-pages/registration-page/RegistrationPage";
import UpdateAdPage from "./pages/main-pages/update-ad-page/UpdateAdPage";
import AdSettingsPage from "./pages/main-pages/ad-settings-page/AdSettingsPage";
import AdminLayout from "./layouts/admin-layout/AdminLayout";
import AdminDashboardPage from "./pages/admin-pages/admin-dashboard-page/AdminDashboardPage";
import AdminUsersPage from "./pages/admin-pages/admin-users-page/AdminUsersPage";
import AdminAdsPage from "./pages/admin-pages/admin-ads-page/AdminAdsPage";
import AdminBoostreqPage from "./pages/admin-pages/admin-boost-req-page/AdminBoostreqPage";
import UnauthorizedPage from "./pages/auth-pages/unauthorized-page/UnauthorizedPage";
import ForgotPasswordPage from "./pages/auth-pages/forgot-password-page/ForgotPasswordPage";
import AboutUsPage from "./pages/main-pages/about-us-page/AboutUsPage";
import SellFastPage from "./pages/main-pages/sell-fast-page/SellFastPage";
import PrivacyPolicyPage from "./pages/main-pages/privacy-policy-page/PrivacyPolicyPage";
import SitemapPage from "./pages/main-pages/sitemap-page/SitemapPage";
import SafetyTipsPage from "./pages/main-pages/safety-tips-page/SafetyTipsPage";
import FaqPage from "./pages/main-pages/faq-page/FaqPage";
import MembershipPage from "./pages/main-pages/membership-page/MembershipPage";
import BannerAdsPage from "./pages/main-pages/banner-ads-page/BannerAdsPage";
import BoostAdPage from "./pages/main-pages/boost-ad-page/BoostAdPage";
import ContactUsPage from "./pages/main-pages/contact-us-page/ContactUsPage";
import AdminThirdPartyAdsPage from "./pages/admin-pages/admin-third-party-ads-page/AdminThirdPartyAdsPage";

function Classifieds() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          {/* Public Site */}
          <Route element={<MainLayout />}>
            <Route path="/" element={<LandingPage />} />
            <Route path="/ads" element={<AdListingPage />} />
            <Route path="/ads/:adId" element={<AdPage />} />
            <Route path="/create-ad" element={<CreateAdPage />} />
            <Route path="/update-ad" element={<UpdateAdPage />} />
            <Route
              path="/seller-profile/:sellerId"
              element={<SellerProfilePage />}
            />
            <Route path="/profile-settings" element={<ProfileSettingsPage />} />
            <Route path="/ad-settings" element={<AdSettingsPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/about-us" element={<AboutUsPage />} />
            <Route path="/sell-fast" element={<SellFastPage />} />
            <Route path="/safety-tips" element={<SafetyTipsPage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/sitemap" element={<SitemapPage />} />
            <Route path="/membership" element={<MembershipPage />} />
            <Route path="/banner-ads" element={<BannerAdsPage />} />
            <Route path="/boost-ad" element={<BoostAdPage />} />
            <Route path="/contact-us" element={<ContactUsPage />} />
          </Route>

          {/* Admin Area */}
          <Route element={<AdminLayout />}>
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
            <Route path="/admin/users" element={<AdminUsersPage />} />
            <Route path="/admin/ads" element={<AdminAdsPage />} />
            <Route
              path="/admin/boost-requests"
              element={<AdminBoostreqPage />}
            />
            <Route
              path="/admin/third-party-ads"
              element={<AdminThirdPartyAdsPage />}
            />
          </Route>

          {/* Auth Pages */}
          <Route element={<AuthLayout />}>
            <Route
              path="/login"
              element={
                <LoginPage
                  title="Seller"
                  navigateTo="/"
                  regPage="/registration"
                />
              }
            />
            <Route
              path="/registration"
              element={
                <RegistrationPage
                  title="Seller"
                  navigateTo="/login"
                  loginPage="/login"
                />
              }
            />
            <Route
              path="/admin/login"
              element={
                <LoginPage
                  title="Admin"
                  navigateTo="/admin/dashboard"
                  regPage="/admin/registration"
                />
              }
            />
            <Route
              path="/admin/registration"
              element={
                <RegistrationPage
                  title="Admin"
                  navigateTo="/admin/login"
                  loginPage="/admin/login"
                />
              }
            />
            <Route path="/email-verify" element={<EmailVerificationPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/unauthorized" element={<UnauthorizedPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default Classifieds;
